//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Helper Imports

import { DataProvider } from "../helpers"
import { DashboardComponent } from "../helpers/dashboard-component"
import { DataProviderRequest } from "./utils"

//#endregion

//#region Model Imports

import { Enums } from "../models/common"
import { ColumnInfo, OpDashboardControl } from "../models/custom"
import { OpAlarmEvent } from "../models/dw"

//#endregion


export class DataProviderAlarmEvent {

    //#region Ctor

    public constructor(private dataProvider: DataProvider) { }

    //#endregion

    //#region Confirm

    public confirmAlarmEvent = (id: ReadonlyArray<number>): DataProviderRequest<OpAlarmEvent[]> => {
        const promise = this.dataProvider
            .sendRequestWithSession('OpxConfirmAlarmEvent', { IdAlarmEvent: id }, 'OpxConfirmAlarmEventResult')
            .then((data: OpAlarmEvent[]) => {
                const result: OpAlarmEvent[] = DataProvider.convertArrayResult<OpAlarmEvent>(data, OpAlarmEvent)

                return OpAlarmEvent.loadNavigationProperties(this.dataProvider, result)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    //#endregion

    //#region Get

    public getAlarmEvent = (id: number): JQueryPromise<OpAlarmEvent> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetAlarmEvent', { IdAlarm: id }, 'OpxGetAlarmEventResult')
            .then((data: any) => {
                if (data != null) {
                    const result: OpAlarmEvent = new OpAlarmEvent(data)

                    return OpAlarmEvent
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((result: OpAlarmEvent[]) => {
                            return _.first(result)
                        })
                }

                return null
            })
    }

    public getAlarmEventFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpAlarmEvent>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdAlarmEvent, 'OpxAlarmEventFilter', 'OpxAlarmEventFilterResult')
    }

    public getAlarmEventSummary = (idOperator: number): JQueryPromise<OpDashboardControl[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetAlarmEventSummary', { idOperator }, 'OpxGetAlarmEventSummaryResult')
            .then((result: any[]) => {
                if (result) {
                    return DashboardComponent.CreateDashboardControl(result)
                }

                return []
            })
    }

    //#endregion
}